export const subtaskEn = {
  subtasks: 'Subtasks',
  createSubtask: 'Create subtask',
  creatingSubtask: 'Creating subtask',
  enterTitle: 'Enter subtask name',
  save: 'save',
  assignedUsers: 'Subtask assigned user',
  choose: 'Choose from existing',
  withoutName: 'Without name',
  removeFromSubtasks: 'Remove from subtasks',
  location: 'Task location',
  withoutBoard: 'Without a board',
  noBoard: 'Task is without a board. Click to place on the board',
  noBoardSubtask: 'Subtask is without a board. Click to place on the board',
  placement: 'Placement on the board',
  noPermissionForTask: "You don't have permission for this task",
  noPermissionForLocation: "You don't have permission for the location",
  openSubtasks: 'Click to open subtasks tree',
  closeSubtasks: 'Click to close subtasks tree',
  subtasksTree: 'Subtasks tree',
  rollup: 'Roll up',
  backToParent: 'Back to parent task',
  deadline: 'Subtask deadline range',
  parentTasks: 'Parent tasks',
  addExistingOneAsSubtask: 'Add an existing one as a subtask',
  removeFromBoard: 'Remove from board',
  filterNotSubtasks: 'Without subtasks (only tasks on board)',
  filterLevel1: '1st level subtasks',
  filterOther: 'Deeper subtasks',
  addParentFromExisting: 'Add parent from existing',
  addingParentTask: 'Adding parent task'
}

export const subtaskRu: typeof subtaskEn = {
  subtasks: 'Подзадачи',
  createSubtask: 'Создать подзадачу',
  creatingSubtask: 'Добавление подзадачи',
  enterTitle: 'Введите название подзадачи',
  save: 'Сохранить',
  assignedUsers: 'Исполнители подзадач',
  choose: 'Выбрать из существующих',
  withoutName: 'Без названия',
  removeFromSubtasks: 'Убрать из подзадач',
  location: 'Расположение задачи',
  withoutBoard: 'Без доски',
  placement: 'Размещение на доске',
  parentTasks: 'Родительские задачи',
  noPermissionForTask: 'У вас нет доступа для просмотра задачи',
  noPermissionForLocation: 'У вас нет доступа для просмотра',
  openSubtasks: 'Нажмите, чтобы раскрыть дерево подзадач',
  closeSubtasks: 'Нажмите, чтобы скрыть дерево подзадач',
  subtasksTree: 'Дерево подзадач',
  rollup: 'Свернуть',
  backToParent: 'Назад к родительской задаче',
  deadline: 'Диапазон дедлайнов подзадач',
  noBoard: 'Задача без доски. Нажмите, чтобы разместить на доску',
  noBoardSubtask:
    'Подзадача, не вынесенная на доску. Нажмите, чтобы разместить на доску',
  addExistingOneAsSubtask: 'Добавить подзадачу из существующих',
  removeFromBoard: 'Убрать с доски',
  filterNotSubtasks: 'Без подзадач (только задачи доски)',
  filterLevel1: 'Подзадачи 1-го уровня',
  filterOther: 'Подзадачи остальных уровней',
  addParentFromExisting: 'Добавить родителя из существующих',
  addingParentTask: 'Добавление родительской задачи'
}
